<!--
통관정보 무시(검사안함) 설정
------------------------------------
-->
<template>
    <!-- 폼 화면 -->

    <div class="confirm-overlay" ref="confirm-overlay" v-show="display">
        <div class="confirm-dialog p-1rem">

            <!-- 하우스정보
            <div class="">
                <i class="material-icons">do_not_disturb</i>
                <b>통관정보 검사안함 설정</b>
            </div>
-->
            <div class="mt-1rem">
                <div class="font-bold">
                    <span class="uk-text-danger">[주의]</span>
                    [통관정보 검사안함 설정] 하시기 전에, 반드시 아래 내용 확인 바랍니다.

                </div>

                <div class="mt-0d5rem ">
                    <span class="bg-yellow">[통관정보 검사안함 설정]하시면, 통관정보 불일치 상태로 출고되며,</span><br />
                    <span class="bg-yellow">올바른 통관정보를 제공해 주셔야 통관이 가능합니다.</span>
                </div>

                <!-- [TASK-153] 기설정(IGNORE) 안내 (D-5 재설정 허용) -->
                <div class="mt-0d5rem" v-if="house.customs_validation === 99">
                    현재 적용 중 — 기존 사유: {{ house.ignore_customs_validation_reason }}
                </div>
            </div>

            <table class="info-table small uk-width-1-1 border-highlight mt-1rem">
                <colgroup>
                    <col style="width: 9rem">
                    <col>
                </colgroup>

                <tr>
                    <th class="uk-text-right">
                        검사안함 사유
                    </th>
                    <td>
                        <app-input-textarea
                            :rows="3"
                            placeholder="통관정보를 올바르게 기입할 수 없는 사유를 정확하게 작성하세요."

                            v-model.trim="inputs.reason"
                        ></app-input-textarea>
                    </td>

                </tr>


            </table>

            <div class="uk-text-right mt-1rem">

                <!--- 버튼 -->
                <button
                    type="button"
                    class="uk-button uk-button-default"

                    @click="hideForm"
                >
                    <span uk-icon="icon: close"></span> 취소
                </button>


                <button
                    type="button"
                    class="uk-button uk-button-danger"

                    @click="submit"
                >
                    <span uk-icon="icon: check"></span>
                    통관정보 검사안함 설정완료
                </button>
            </div>

        </div>
    </div>

</template>

<script>

export default {
    mixins: [
    ],
    props: {
        // csrf-token
        csrfToken: String,

        // (object) 하우스정보
        house: {
            type: Object,
            default: null,
        },

        // [TASK-153] 완료 후 페이지 새로고침 여부 (상세 상시 버튼 경유 시 true)
        refreshWhenDone: {
            type: Boolean,
            default: false,
        },
    },
    data: function () {
        return {
            // (bool) 폼 display 여부
            display: false,

            /**
             * 입력값
             */
            inputs: {
                reason: null,
            },
        };
    },
    mounted: function () {
        //console.log('mounted in component');
    },
    computed: {
    },
    methods: {
        /**
         * 입력폼 display
         */
        displayForm() {
            // 컨펌 엘리먼트 body 밑으로 이동
            document.body.appendChild(this.$refs['confirm-overlay']);
            this.display = true;
        },

        /**
         * 입력폼 hide
         */
        hideForm() {
            // 컨펌 엘리먼트 body 밑으로 이동
            this.display = false;
        },

        /**
         * 폼 띄우기
         */
        form() {
            // 입력값 설정
            this.inputs.reason = null;

            //console.log(response);
            // 폼띄우기
            this.displayForm();
        },

        /**
         * 서브밋 전 검증
         * @return Promise
         */
        submitValidation() {
            return new Promise((resolve, reject) => {
                // 입력값 검증
                if (! this.inputs.reason) {
                    reject('사유는 필수입니다.');
                    return;
                }

                resolve();
            });


        },

        /**
         * submit
         */
        submit() {
            // 입력값 검증처리
            this.submitValidation().then(() => {
                return new Promise((resolve, reject) => {

                    // ajax 옵션
                    let opts = {
                        type: 'patch',
                        url: '/houses/' + this.house.id + '/ignore-customs-validation',
                        data: _.merge({
                            '_token': this.csrfToken,
                        }, this.inputs),
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.default(opts);
                });
            }).then((response) => {
                this.display = false;
                UIkit.modal.alert(response.msg).then(() => {
                    // [TASK-153] 상세 상시 버튼 경유 시 새로고침 (customs.blade.php 에서 refresh-when-done 전달)
                    if (this.refreshWhenDone) {
                        $.app.refresh();
                    }

                    // 완료이벤트
                    this.$emit('done');

                });
            }).catch((msg) => {
                alert(msg);
            });



        },
    },
}
</script>

<style lang="scss" scoped>


// 컨펌화면
.confirm-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 9999;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .confirm-dialog {
        width: 50rem;
        max-width: 90%;

        background-color: #fff;

    }
}
</style>